import { FormikHelpers } from "formik";
import AtmServiceProviderForm from "./AtmServiceProviderForm";
import { useGetAtmServiceProvider } from "./api/getAtmServiceProvider";
import { useEditAtmServiceProvider } from "./api/editAtmServiceProvider";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditAtmServiceProvider = ({handleCloseModal, atmServiceProviderId}: EditAtmServiceProviderProps)  => {
  const getAtmServiceProviderQuery = useGetAtmServiceProvider({atmServiceProviderId: atmServiceProviderId})
  const editAtmServiceProviderMutation = useEditAtmServiceProvider({data: {}, atmServiceProviderId});

  const handleSubmit = async (values: IPostEditAtmServiceProvider, { setSubmitting }: FormikHelpers<IPostEditAtmServiceProvider>): Promise<void> => {
    try {
      await editAtmServiceProviderMutation.mutateAsync({
        data: values,
        atmServiceProviderId: atmServiceProviderId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    }finally{
      setSubmitting(false);
    }
  }

  if (getAtmServiceProviderQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getAtmServiceProviderQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του ATM Service Provider.</div>
    )
  }

  return (
    <>
      {!getAtmServiceProviderQuery.isLoading && getAtmServiceProviderQuery.data &&
        <AtmServiceProviderForm initialValues={getAtmServiceProviderQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditAtmServiceProviderProps {
  atmServiceProviderId: number;
  handleCloseModal: () => void;
}

export default EditAtmServiceProvider;